import React from "react";
import { Sparkles } from "lucide-react";

// Floating sparkle dots positioned via inline style array
// Usage: <SparkleField count={12} className="..." />
export function SparkleField({ count = 10, className = "" }) {
  const dots = React.useMemo(() => {
    return Array.from({ length: count }).map((_, i) => ({
      top: Math.random() * 100,
      left: Math.random() * 100,
      delay: Math.random() * 3,
      scale: 0.6 + Math.random() * 1.2,
      kind: i % 3,
    }));
  }, [count]);

  return (
    <div
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {dots.map((d, i) => (
        <span
          key={i}
          className="absolute animate-sparkle"
          style={{
            top: `${d.top}%`,
            left: `${d.left}%`,
            animationDelay: `${d.delay}s`,
            transform: `scale(${d.scale})`,
          }}
        >
          {d.kind === 0 ? (
            <Sparkles
              className="text-hotpink/80"
              style={{ width: 18, height: 18 }}
            />
          ) : d.kind === 1 ? (
            <FourPointStar size={14} fill="#ff3ea5" opacity={0.85} />
          ) : (
            <FourPointStar size={10} fill="#ffd1e4" opacity={0.95} />
          )}
        </span>
      ))}
    </div>
  );
}

export function FourPointStar({ size = 16, fill = "#ff3ea5", opacity = 1 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ opacity }}
      aria-hidden="true"
    >
      <path
        d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z"
        fill={fill}
      />
    </svg>
  );
}

export function Bow({ size = 80, className = "", color = "#ffb6c1" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M50 50 C30 35 15 35 15 50 C15 65 30 65 50 50 Z M50 50 C70 35 85 35 85 50 C85 65 70 65 50 50 Z"
        fill={color}
      />
      <rect x="46" y="46" width="8" height="14" rx="2" fill={color} />
    </svg>
  );
}
